import React, { useEffect, useState } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';
import { MuiThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { history } from '../history';
import GlobalProvider from '../store/GlobalProvider';
import mainTheme from '../common/theme';
import LoginPage from './LoginPage/LoginPage';
import HomePage from './HomePage/HomePage';
import docCookies from '../docCookies';
import axios from 'axios';
import BundleProvider from '../BundleProvider/BundleProvider';
import ToastContainner from '../common/elements/ToastContainer'

const RouteGuard = Component => ({ match }) => {
  const loggedIn = docCookies.hasItem('jwt');
  let route = <Component match={match} />;
  if (!loggedIn) {
    route = <Redirect to="/login" />;
  } else {
    if (match.path === '/') route = <Redirect to="/home" />;
    axios.defaults.headers.common['Authorization'] = docCookies.getItem('jwt');
  }
  return route;
};

export const Main = () => {
  const [defaultLocale, setDefaultLocale] = useState('en-US');
  const [phraseProjectId, setPhraseProjectId] = useState('');

  const changeFavIcon = url => {
    if (url) {
      const favicon = document.getElementById('favicon');
      favicon.href = url;
    }
  };

  useEffect(() => {
    axios.get('/api/v2/settings').then(({ data }) => {
      changeFavIcon(data.favicon_url);
      setDefaultLocale(data.default_locale);
      setPhraseProjectId(data.phrase_business_portal_project_id);
    });
  }, []);

  return phraseProjectId ? (
    <GlobalProvider>
      <BundleProvider defaultLocale={defaultLocale} projectID={phraseProjectId}>
        <MuiThemeProvider theme={mainTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
              <Router history={history} basename={process.env.PUBLIC_URL}>
                <div>
                  <Switch>
                    <Route path="/reset/:uid/:token" component={LoginPage} />
                    <Route exact path="/login" component={LoginPage} />
                    <Route exact path="/home" render={RouteGuard(HomePage)} />
                    <Route path="/" render={RouteGuard(HomePage)} />
                  </Switch>
                  <ToastContainner />
                </div>
              </Router>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </BundleProvider>
    </GlobalProvider>
  ) : null;
  // Consider adding a failed render state to replace null
};
